import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {LocalForm} from 'react-redux-form';

class CustomForm extends Component {
	render() {
		const {model, validators, validateOn, hideNativeErrors, ...rest} = this.props;

		return (
			<LocalForm model={model}
			           validateOn={validateOn}
			           validators={validators}
			           hideNativeErrors={hideNativeErrors}
			           {...rest}
			>
				{this.props.children}
			</LocalForm>
		)
	}
}

CustomForm.defaultProps = {
	validateOn: 'submit',
	hideNativeErrors: true
};

CustomForm.propTypes = {
	model: PropTypes.string.isRequired,
	validators: PropTypes.object.isRequired,
	validateOn: PropTypes.string,
	hideNativeErrors: PropTypes.bool
};

export default CustomForm;